import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { Zone, ZoneMetadata } from "../methodology/zone";
import { Team } from "./team";

export class TeamLocation extends BaseEntity<TeamLocation> {
    public teamLocationId!: number;
    public teamId!: number;
    public parentTeamId?: number;
    public ordinal!: number;
    public zone!: Zone | null;
    public span?: number;

    public team!: Team;
    public parentTeam?: Team;

    public static getAsZoneLocation(location?: Partial<TeamLocation>) {
        if (location && location.zone !== null && location.zone !== undefined) {
            return location.zone;
        }

        return undefined;
    }

    public static getAsParentTeamLocation(location?: Partial<TeamLocation>) {
        if (location && location.parentTeam !== null && location.parentTeam !== undefined) {
            return location.parentTeam;
        }

        return undefined;
    }

    public static getAsChildTeamLocation(location?: Partial<TeamLocation>) {
        if (location && location.team !== null && location.team !== undefined) {
            return location.team;
        }

        return undefined;
    }

    public static compare(a: TeamLocation, b: TeamLocation) {
        if (a.zone && b.zone) {
            return ZoneMetadata.Ordinal[a.zone] - ZoneMetadata.Ordinal[b.zone];
        } else if (a.zone && !b.zone) {
            return -1;
        } else if (!a.zone && b.zone) {
            return 1;
        } else {
            return a.ordinal - b.ordinal;
        }
    }

    public static group(location?: Partial<TeamLocation>) {
        if (TeamLocation.getAsZoneLocation(location)) {
            return "Zones";
        }

        if (location?.parentTeam) {
            return `${location.parentTeam.teamTypeName}s`;
        }

        return undefined;
    }

    public get isActiveLocation() {
        return this.team?.isActive()
            && (!this.parentTeam || this.parentTeam.isActive());
    }
}

export const TeamLocationBreezeModel = new BreezeModelBuilder("TeamLocation", TeamLocation)
    .hasSource()
    .withSortField("ordinal")
    .isOrganisationEntity()
    .alwaysFetchingNestedNavigationProperty("team.teamLeaderPerson")
    .withActivePath("team")
    .withActivePath("parentTeam")
    .build();
